import * as msal from "@azure/msal-browser";
import modernAuthenticationService from '../services/ModernAuthenticationService';

declare const window: any;

enum AuthenticatedStateType {
  SignedIn = '1',
  NotSignedIn = '3'
}

/**
 * This class is intentionally kept here for backward compatibility for mock tests and other dependent utils,
 * moving forward don't directly consume it, use modernAuthenticationService instead.
 */
export class AuthenticationService {
  private debugMode: boolean;

  constructor() {
    this.debugMode = process.env.REACT_APP_DEBUG_MODE === "1";
    
    if (this.debugMode) {
      console.warn('AuthenticationService is deprecated. Use modernAuthenticationService instead.');
    }
  }

  public async login() {
    await modernAuthenticationService.waitForInitialization();
    return modernAuthenticationService.login();
  }

  public async logout() {
    await modernAuthenticationService.waitForInitialization();
    return modernAuthenticationService.logout();
  }

  public handleLoginPromise(): Promise<boolean> {
    return modernAuthenticationService.handleRedirectPromise();
  }

  public isAuthenticatedPromise(): Promise<boolean> {
    return modernAuthenticationService.isAuthenticatedAsync();
  }

  public async getToken(): Promise<string | null> {
    await modernAuthenticationService.waitForInitialization();
    return modernAuthenticationService.getToken();
  }

  public get cachedToken(): string {
    // This is a legacy property, we'll need to get the token synchronously
    // In the modern implementation, tokens should be retrieved asynchronously
    console.warn('cachedToken is deprecated. Use getToken() instead.');
    return '';
  }

  public get accountInfo(): msal.AccountInfo | null {
    return modernAuthenticationService.accountInfo;
  }

  public getTokenExpirationInMinutes(token: string): number {
    return modernAuthenticationService.getTokenExpirationInMinutes(token);
  }

  public get isAuthenticated() {
    return modernAuthenticationService.isAuthenticated;
  }

  public loadMeControl() {
    modernAuthenticationService.loadMeControl();
  }
}

const authenticationService = new AuthenticationService();
export default authenticationService;
